/**
 * @module icon.transformer
 */

/**
 * Create "icon" entities for the front-end
 *
 * @example icon (from server)
 * {
 *   "name": "sliding_thumbs_up",
 *   "path": "sliding_thumbs_up",
 *   "surveyElementTypeId": 1
 * }
 */
const iconFrom = (icon = {}) => {
  return {
    // @ts-expect-error TS(2339): Property 'id' does not exist on type '{}'.
    id: icon.id,
    // @ts-expect-error TS(2339): Property 'name' does not exist on type '{}'.
    name: icon.name,
    // @ts-expect-error TS(2339): Property 'path' does not exist on type '{}'.
    path: icon.path,
    // @ts-expect-error TS(2339): Property 'surveyElementTypeId' does not exist on t... Remove this comment to see the full error message
    surveyElementTypeId: icon.surveyElementTypeId,
  };
};

const iconsFrom = (iconsList = []) => {
  const icons = iconsList.map((icon) => iconFrom(icon));

  return icons;
};

export { iconFrom, iconsFrom };
